<template>
  <div id="caseWorkers">
    <v-container class="pa-0">
      <v-layout>
        <router-link to="/agency/account/add">
          <v-flex class="xs12 sm12 mb-5">
            <v-btn fab absolute right class="mr-3 pf-btn-fab">
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex>
        </router-link>
      </v-layout>
    </v-container>
    <v-container grid-list-md fluid class="pt-0">
      <v-card class="mt-1">
        <v-data-table :headers="headers" :items="caseWorkerData" :search="search" class="pf-data-table"
          :pagination.sync="pagination">
          <template v-slot:items="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.phone }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.user ? props.item.user.username : "" }}</td>
            <td width="130px" align="left">
              <v-tooltip top>
              <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn icon class="ma-0" @click="notifyUser(props.item)" small>
                <v-icon size="22" class="grey--text" >fa-bell</v-icon>
                </v-btn>
              </span>
              </template>
              <span>Notify User</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn icon class="ma-0" @click="editItem(props.item)" small>
                <v-icon size="22" class="grey--text" >edit</v-icon>
                </v-btn>
              </span>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn icon class="ma-0" @click="deleteItem(props.item)" small>
                <v-icon size="22" class="grey--text" >delete_outline</v-icon>
                </v-btn>
              </span>
              </template>
              <span>Delete</span>
            </v-tooltip>
              <!-- <v-btn icon @click="deleteItem(props.item)">
                <v-icon size="22" class="pf-icon-delete">delete_outline</v-icon>
              </v-btn>
              <v-btn icon @click="editItem(props.item)">
                <v-icon size="22" class="pf-icon-delete">edit_outline</v-icon>
              </v-btn>   -->
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>
  
<script>
/* global session store config  */
import swal from 'sweetalert2';
import { editItem, getCollection, request } from '../../../helpers/helpers';
import { mapGetters } from 'vuex';

// This lists all the countries and allow to edit them.
export default {
  name: 'CaseWorker',
  data: () => ({
    entity: 'CaseWorker',
    search: '',
    headers: [
      { text: 'Name', width: '150px', value: 'name', align: 'left' },
      { text: 'Phone', width: '150px', value: 'phone', align: 'left' },
      { text: 'Email', width: '150px', value: 'email', align: 'left' },
      { text: 'Username', width: '150px', value: 'username', align: 'left' },
      { text: 'Action', width: '150px', value: '', align: 'left' },
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    },
    caseWorkerData: []
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['Agency']),
    CaseWorker: {
      get () {
        return store.state.CaseWorker;
      },
      set (value) {
        store.commit('setCaseWorker', value);
      }
    }
  },
  created () {
    this.initialize();
  },
  methods: {
    // @vuese
    // Used to fetch the badge Contact list if not already exists
    async initialize  () {
      if (!this.caseWorkerData.length) {
        let where = { 'agency': this.Agency.id };
        let populate = [{ path: 'user', select: 'username user_email password' }];
        let { error, data } = await getCollection(this.entity, true, 0, populate, where, null, null);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.caseWorkerData = data;
          }
        }
      }
    },
    deleteItem (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data } = await request(`CaseWorker/${item.id}`, 'DELETE');
            if (error) {
              console.log('error', error);
            } else {
              const index = this.caseWorkerData.indexOf(item);
              this.caseWorkerData.splice(index, 1);
              swal.fire(
                'Deleted!',
                'The Account "' + item.first_name + ' ' + item.last_name + '" has been deleted.',
                'success'
              );
            }
          })();
        }
      });
    },
    editItem (item) {
      if (item) {
        this.$router.push({ path: `/agency/account/${item._id}` });
      }
    },
    notifyUser (item) {
      (async () => { 
        let name = item.first_name + ' ' + item.last_name;
        let payload = item;
        payload.name = name;
        payload.agency = this.Agency.id;
        window.getApp.$emit('LoadingText', 'Notifying User..');
        let { error, data } = await request(`Caseworker/notifyUser`, 'POST', payload);
        if (error) {
          console.log('error', error);
        } else {
          swal.fire(
            'Email Sent!',
            'Email sent to "' + item.email,
            'success'
          );
        }      
      })();
     
    }

  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Agencies/CaseWorker/case-worker.vue